import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";

import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function AssistantAgentsTable(props) {
  const { agents, assistantNameById, onAgentEdit, onAgentDelete, showActions } =
    props;

  if (agents.length === 0) {
    return (
      <div className="flex items-center justify-center h-full min-h-96">
        <p className="text-lg font-medium">No assistant agents</p>
      </div>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableHeader>Agent</TableHeader>
        <TableHeader>Transfer To Assistant</TableHeader>
        <TableHeader>Trigger</TableHeader>
        {showActions && <TableHeader>Actions</TableHeader>}
      </TableHead>
      <TableBody>
        {agents.map((agent, idx) => {
          const targetName = assistantNameById?.[agent.assistantId];
          return (
            <TableRow key={agent._id ?? idx}>
              <TableCell>
                <p className="text-sm font-medium">{agent.name}</p>
              </TableCell>
              <TableCell>
                {targetName ? (
                  <Badge color="blue">{targetName}</Badge>
                ) : (
                  <Badge color="amber">Unknown assistant</Badge>
                )}
              </TableCell>
              <TableCell>
                {agent.trigger ? (
                  <p className="text-sm max-w-md truncate">{agent.trigger}</p>
                ) : (
                  <Badge>n/a</Badge>
                )}
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex gap-x-2">
                    <Button outline onClick={() => onAgentEdit(agent, idx)}>
                      <PencilIcon />
                    </Button>
                    <Button outline onClick={() => onAgentDelete(agent, idx)}>
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
